import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './navBar';
import Footer from '../components/faq';

const TermAndCondition = () => {
  const navigate = useNavigate();

  const sections = [
    {
      title: 'Effective Date: 02-11-2023',
      content: [],
    },
    {
      title: '1. Acceptance of Terms',
      content: [
        'By using routeBilling, you confirm that you accept these Terms & Conditions in full. If you do not agree to these terms, you must not use our application.',
      ],
    },
    {
      title: '2. Description of Service',
      content: [
        'routeBilling is a web application designed to streamline route management, billing, inventory tracking, and related business operations. The features include, but are not limited to:',
        'On-Site Billing',
        'Route Wise Stock',
        'Route Account Balance',
        'Route Party Wise Balance',
        'Cash Collection',
        'Credit Billing',
        'Route Wise Issue Material',
        'Dashboard and Analytics',
        'Warehouse/Supplier Dashboard',
      ],
    },
    {
      title: '3. User Responsibilities',
      content: [
        'Provide accurate and complete information when creating an account or using routeBilling.',
        'Maintain the confidentiality of your account credentials and not share them with unauthorized parties.',
        'Use the application only for lawful business purposes and in compliance with all applicable laws.',
        'Ensure proper handling of financial and customer data in accordance with privacy regulations.',
      ],
    },
    {
      title: '4. Accounts, Billing, and Financial Year',
      content: [
        'Users are responsible for all activities conducted under their account.',
        'Any billing, payment, or account management functionalities must be used as intended within the application.',
        'routeBilling keeps only one year of user data. Users must close their financial year within the application and carry forward balances to the new year.',
        'routeBilling reserves the right to suspend or terminate accounts that violate these Terms & Conditions.',
      ],
    },
    {
      title: '5. Intellectual Property',
      content: [
        'All content, software, features, and technology associated with routeBilling are the exclusive property of Genius Office and protected by copyright, trademark, and other intellectual property laws.',
        'Users are not permitted to copy, reproduce, modify, or distribute any part of the application without prior written consent.',
      ],
    },
    {
      title: '6. Data and Privacy',
      content: [
        'Users retain ownership of their business and customer data.',
        'routeBilling may collect and process data to improve services but will not share personal or business data with third parties without consent, except as required by law.',
        'Users are responsible for backing up their data and ensuring data accuracy.',
      ],
    },
    {
      title: '7. Limitation of Liability',
      content: [
        'routeBilling is provided “as is,” without warranties of any kind, either express or implied.',
        'Genius Office is not liable for any direct, indirect, incidental, or consequential damages arising from the use or inability to use the application.',
        'Users are responsible for all business decisions based on the information provided by the application.',
      ],
    },
    {
      title: '8. Modifications',
      content: [
        'Genius Office reserves the right to modify these Terms & Conditions at any time.',
        'Users will be notified of changes, and continued use of the application constitutes acceptance of the revised terms.',
      ],
    },
    {
      title: '9. Termination',
      content: [
        'Genius Office may suspend or terminate access to the application at any time, with or without notice, for conduct that violates these Terms & Conditions or for operational reasons.',
      ],
    },
    {
      title: '10. Governing Law',
      content: [
        'These Terms & Conditions shall be governed by and construed in accordance with the laws of India, and any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts in Jalandhar, Punjab.',
      ],
    },
    {
      title: '11. Contact Us',
      content: [
        'Genius Office',
        'Jalandhar City, India',
        'Website: www.geniusoffice.com',
        'Email: support@geniusoffice.com',
        'Website: www.routeBilling.online',
      ],
    },
    {
      title: 'Acknowledgment',
      content: [
        'By using routeBilling, you acknowledge that you have read, understood, and agree to these Terms & Conditions, including the one-year data retention policy and financial year closure requirement.',
      ],
    },
  ];

  return (
    <div className="h-screen w-screen bg-gradient-to-b from-[#d7daf5] to-white">
      <Navbar isShowShadow={true} />
      <div className="container pt-[150px] mx-auto overflow-y-auto border-b">
        <div className="px-4">
          <div className="text-3xl font-bold text-center mb-6">
            Terms & Conditions
          </div>
          <div className="text-gray-500 text-center mb-10">
            Welcome to routeBilling! By accessing or using our web application,
            you agree to comply with and be bound by these Terms & Conditions.
            Please read them carefully.
          </div>

          {sections.map((section, idx) => (
            <div key={idx} className="mb-6">
              {section.title && (
                <h2 className="text-lg font-semibold mb-2">{section.title}</h2>
              )}
              {section.content.length > 0 && (
                <ul className="list-disc ml-6 text-gray-600 space-y-2">
                  {section.content.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
      <Footer onlyFooter={true} />
    </div>
  );
};

export default TermAndCondition;
